import { filter, map, tap, ignoreElements } from 'rxjs';
import { LocationType, searchParametersActions } from 'features/searchResultsFacets';
import { locationSelected$ } from './observables';

const RECTANGULAR_AREA = LocationType.RectangularArea.toString();

/**
 * Extracts valid, finite origin coordinates from a fetchLocations payload.
 * Returns null for a rectangular-area search (button click, drag-to-refetch, or
 * autoSearchWithinMap activation) — the map must stay exactly where the user left
 * it in that flow, never recenter — and, redundantly, for any payload that lacks
 * originLatitude/originLongitude (which is always true for rectangular-area anyway,
 * but the locationType check makes the exclusion explicit rather than incidental).
 */
function extractOrigin({ locationType, originLatitude, originLongitude } = {}) {
  if (locationType === RECTANGULAR_AREA) {
    return null;
  }

  const latitude = Number(originLatitude);
  const longitude = Number(originLongitude);

  return Number.isFinite(latitude) && Number.isFinite(longitude)
    ? { latitude, longitude }
    : null;
}

/**
 * Bridges the fetchLocations action into locationSelected$ so mapViewport.plugin
 * can react to "the user explicitly selected a location" as an event, rather than
 * to the resulting Redux state value (which is indistinguishable from "unchanged"
 * when the same location is selected again).
 */
const locationSelectedEpic = (action$) => action$.pipe(
  filter(searchParametersActions.fetchLocations.match),
  map((action) => extractOrigin(action.payload)),
  filter(Boolean),
  tap((origin) => locationSelected$.next(origin)),
  ignoreElements(),
);

export default locationSelectedEpic;
